


























































import Vue from 'vue'
import { CommonAppData } from '@/common/types/commonAppData'
import { ProductCategory } from '@/model/productCategory'

const MENU_PAGES = {
  PARENT_CAT: 'parent_category',
  CHILD_CAT: 'child_category'
}
export default Vue.extend({
  props: {
    applicationData: {
      type: Object as () => CommonAppData,
      required: true
    }
  },
  data(): {
    activeMenu: string
    MENU_PAGES: {[key: string]: string}
    activeParentCategory: number
  } {
    return {
      activeMenu: MENU_PAGES.PARENT_CAT,
      MENU_PAGES: MENU_PAGES,
      activeParentCategory: -1
    }
  },
  computed: {
    parentCategories(): ProductCategory[] {
      return this.applicationData.product_categories
    },
    childCategories(): ProductCategory[] {
      return this.parentCategories.find(item => item.id === this.activeParentCategory)?.child_categories || []
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    activateParentCategoryMenu() {
      this.activeMenu = this.MENU_PAGES.PARENT_CAT
    },
    onSelectParentCategory(item: ProductCategory) {
      if (item.child_categories && item.child_categories.length > 0) {
        this.activeParentCategory = item.id
        this.activeMenu = this.MENU_PAGES.CHILD_CAT
      } else {
        window.location.href = item.url
      }
    }
  }
})
